import type { SchemaField } from '@cli-types/core-engine/schema.js'

export function getFormFieldType(field: SchemaField): string {
  switch (field.type) {
    case 'boolean':
      return 'checkbox'
    case 'email':
      return 'email'
    case 'text':
      return 'textarea'
    case 'markdown':
      return 'markdown'
    case 'richtext':
      return 'richtext'
    case 'number':
    case 'decimal':
      return 'number'
    case 'date':
      return 'date'
    case 'time':
      return 'time'
    case 'timestamp':
      return 'datetime-local'
    default:
      return 'text'
  }
}
